// ============================================================
// MUI Shadows Configuration — Soft shadows, no harsh edges
// ============================================================

import { tokens } from './tokens';

// MUI expects exactly 25 shadow values (index 0-24).
// We map our token shadows to appropriate elevation levels.
const s = tokens.shadows;

export const shadows = [
  s.none,   // 0
  s.xs,     // 1
  s.sm,     // 2
  s.sm,     // 3
  s.md,     // 4
  s.md,     // 5
  s.md,     // 6
  s.lg,     // 7
  s.lg,     // 8
  s.lg,     // 9
  s.lg,     // 10
  s.xl,     // 11
  s.xl,     // 12
  s.xl,     // 13
  s.xl,     // 14
  s.xl,     // 15
  s.xl,     // 16
  s.xl,     // 17
  s.xl,     // 18
  s.xl,     // 19
  s.xl,     // 20
  s.xl,     // 21
  s.xl,     // 22
  s.xl,     // 23
  s.xl,     // 24
];
